exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cs-SummaryComment {\n  display: table-row;\n  width: 100%;\n}\n.cs-SummaryComment__Text {\n  padding-top: 5px;\n  padding-bottom: 5px;\n  padding-left: 15px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/SurveySummary/SummaryComment/SummaryComment.less
// module id = 948
// module chunks = 0